// ── User Preferences (Issue #424) ───────────────────────────────────────────────

import type { UserPreferences, UpdateUserPreferencesInput } from '../../types/preferences';
import { apiRequest } from './http';

/**
 * Save the authenticated user's preferences (theme/locale/timezone).
 * Write path is REST per the GraphQL-read/REST-write convention; the read path
 * is the GraphQL `userPreferences` query. The server scopes the write to the
 * JWT subject, so no userId is sent.
 */
export async function updateUserPreferences(
  input: UpdateUserPreferencesInput
): Promise<UserPreferences> {
  return apiRequest<UserPreferences>('/user/preferences', {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}
